import { Flex, Table, Typography, Tag, Spin, Input, Space, Button } from "antd";
import React, { useEffect, useState } from "react";
import Icon from "@ant-design/icons";
import { getRotable } from "../redux/rotableThunk";
import { useSelector, useDispatch } from "react-redux";
import { setRotable, setCurrentPage } from "../redux/rotableSlice";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { setSearchText as rotableText } from '../redux/rotableSlice';

export const RotablePartsComponent = () => {
    const rotableParts = useSelector(state => state.rotableState.rotable);
    const currentPage = useSelector(state => state.rotableState.currentPage);
    const pageSize = useSelector(state => state.rotableState.pageSize);
    const total = useSelector(state => state.rotableState.totalRecords);
    const selectedTags = useSelector(state => state.rotableState.selectedFleet);
    const selectedGroups = useSelector(state => state.rotableState.selectedGroup);
    const queryText = useSelector(state => state.rotableState.searchText);
    const fleets = useSelector(state => state.rotableState.fleets);
    const [loadingStatus,setLoadingStatus] = useState(true);
    const totalROT = useSelector(state => state.rotableState.totalRecords);    
    const dispatch = useDispatch();
    const { Text }= Typography;
    const { Search } = Input;

    const DownloadSvg = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.4">
                <path d="M9 11V17L11 15" stroke="#292D32" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 17L7 15" stroke="#292D32" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#292D32" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#292D32" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );

    const DownloadIcon = (props) => <Icon component={DownloadSvg} {...props} />

    const columns = [       
        {
            title: 'Group Type',
            dataIndex: 'GroupType',
            key: 'GroupType',
            width: 180,
            render: (val) => {
                return ((val!=undefined && val!="")?
                        <Tag style={{fontSize:'0.85rem'}}>{val}</Tag>:undefined)
            }                      
        },          
        {
            title: 'Material',
            dataIndex: 'Material',
            width: 180,
            key: 'Material',
            render: (value) => {
                return <Text style={{fontWeight:500, fontSize:16}}>{value}</Text>
            }            
        },        
        {
            title: 'Description',
            dataIndex: 'Description',
            width: '200',
            key: 'Description',
            render: (value) => {
                return <Text style={{fontWeight:400, fontSize:16}}>{value}</Text>
            }            
        },
        {
            title: 'Serial',
            dataIndex: 'Serial',
            key: 'Serial',
            width: 140,
            align: 'center',
            render: (value) => {
                return <Text style={{fontSize:16}}>{value}</Text>
            }            
        },        
        {
            title: 'Quantity',
            dataIndex: 'Quantity',
            key: 'Quantity',
            width: 110,
            align: 'center',
            render: (value) => {
                return <Text style={{fontSize:16}}>{value}</Text>
            }   
        },
        {
            title: 'Condition',
            dataIndex: 'Condition',
            key: 'Condition',            
            width: 150,
            align: 'center',
            render: (val) => {
                /*
                const applic_arr = val.split(" ");   
                return (
                <Flex style={{flexWrap:"wrap",width:150, justifyContent:'center'}}>
                {                    
                    applic_arr.map((elem)=>{          
                        if (elem!=undefined && elem!="")  
                        {                            
                            return   <Tag style={{borderRadius:10,paddingTop:5,paddingBottom:5,paddingLeft:8,paddingRight:8,marginTop:2,fontSize:'0.9rem',fontWeight:500}}color="magenta">{elem}</Tag>   
                        }                                            
                    })
                }
                </Flex> )
                */
               return <Text style={{fontSize:16}}>{val}</Text>
            }              
        },
        {
            title: 'Manufacturer',
            dataIndex: 'Manufact',
            key: 'Manufacturer',
            width: 150,
            align: 'center',
            render: (value) => {
                return <Text style={{fontSize:16}}>{value}</Text>
            }            
        },
        {
            title: 'Certificate',
            dataIndex: 'Certificate',
            key: 'Certificate',
            width: 115,
            align: 'center',
            filters: [
                {
                    text: 'OEM',
                    value: 'Y'
                },
                {
                    text: 'N/A',
                    value: 'N'
                }
            ],
            onFilter: (value, record) => (value==='Y')?record.Certificate==='Y':(value==='N')?record.Certificate===' ':true,                        
            render: (val) => {
                return (val!=undefined && val==='Y')?
                <Flex style={{gap:4,justifyContent:'center'}}><CheckCircleTwoTone twoToneColor={'#00DC54'} style={{fontSize:16}}/><Text style={{color:'#2e7d32'}}>OEM</Text></Flex>:
                <Flex style={{gap:4,justifyContent:'center'}}><CheckCircleTwoTone twoToneColor={'#9575cd'} style={{fontSize:16}}/><Text style={{color:'#3F075C'}}>N/A</Text></Flex>;
            }    
        }            
      ];

    useEffect(() => {
        if (currentPage!=undefined && currentPage!=0 && pageSize!=undefined) {
            setLoadingStatus(true);
            const params = {'currentPage': currentPage, 'pageSize': pageSize, 'fleet': selectedTags, 'groups': selectedGroups, 'searchText': queryText};
            const getRotableAction = getRotable(params);
            dispatch(getRotableAction).unwrap().then((resp) => {                    
                setLoadingStatus(false);
            });
        }       
    },[currentPage, selectedTags, selectedGroups, queryText]);

    const changePage = (page)=>{
        const setPageAction = setCurrentPage(page);
        dispatch(setPageAction);        
    }

    const searchRotable = (value, _e, info) =>{
        const setSearchAction = rotableText(value);
        dispatch(setSearchAction);
    }

    const exportRotable = () => {
        const fleetString = "Fleets="+selectedTags;
        const groupString = "Groups="+selectedGroups;
        const searchText = "SearchText="+JSON.stringify(queryText);
        window.open(`${process.env.REACT_APP_SERVER_URL}/RotableExporter.ashx?`+fleetString+'&'+groupString+'&'+searchText);
    }

    return (
        <Flex vertical style={{flex:1, width:'100%', gap:30, justifyContent:'center', background:'#ffffff', borderRadius:10, alignItems:'center'}}>    
            <Flex style={{flex:1, width:'98%',paddingTop:10, justifyContent:'space-between'}}>              
              <Search size="large" placeholder='Search' onSearch={searchRotable} allowClear style={{width:'25%'}}/>
              <Flex style={{gap:30}}>
                <Button size="large" onClick={exportRotable} icon={<DownloadIcon/>}  iconPosition="end">Export to Excel</Button>              
                <Space>                
                <Text style={{color:'#3F075C',fontWeight:600, fontSize:22}}>{totalROT.toLocaleString()}</Text><Text style={{color:'#4E5761', fontWeight:400, fontSize:16}}>items</Text>
                </Space>
              </Flex>              
            </Flex>
            <Table 
                style={{width:'98%'}} 
                dataSource={rotableParts} 
                loading={{indicator: <Spin size="large"/>, spinning: loadingStatus}}    
                columns={columns} 
                pagination={{pageSize: pageSize, currentPage: currentPage, total: total, onChange: changePage, showSizeChanger: false}}      
                scroll={{ x: 'max-content', y: 55 * 15 }}                          
            />
        </Flex>
    )
}
